export default function isScrollEnd(e,allowedDistance=5){
    return (
        Math.round(e.target.scrollHeight - e.target.scrollTop) <
         Math.round(e.target.clientHeight+allowedDistance)
    );

}
